<template>
    <Teleport to="body">
        <Transition name="modal">
            <div v-if="visible" class="modal-overlay" @click="handleOverlayClick">
                <div class="modal-container" @click.stop>
                    <!-- 金豆装饰图片 -->
                    <div class="bean-decoration">
                        <img src="@/assets/static/img2/jindou.png" alt="金豆" class="bean-image">
                    </div>
                    <div class="modal-content-wrapper">
                        <div class="modal-header">
                        <div class="header-content">
                            <div class="title-section">
                                <div class="title-content">
                                    <h2 class="modal-title">充值豆豆</h2>
                                    <p class="modal-subtitle">豆豆可用来购买值得物品</p>
                                </div>
                            </div>
                            <button class="close-button" @click="handleClose">
                                <Close />
                            </button>
                        </div>
                        
                        <div class="balance-info">
                            <div class="balance-card">

                                <div class="balance-content">
                                    <span class="balance-label">当前剩余：</span>
                                    <span class="balance-value">
                                        <span class="balance-number">{{ userInfo.points_balance || 0 }}</span>
                                        <span class="balance-unit"> 豆豆</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="modal-body">
                        <div class="section">
                            <h3 class="section-title">选择充值金额</h3>
                            <div v-if="loading" class="loading-container">
                                <div class="loading-spinner"></div>
                                <div class="loading-text">加载套餐中...</div>
                            </div>
                            <div v-else class="amount-grid">
                                <div
                                    v-for="option in rechargeOptions"
                                    :key="option.amount"
                                    class="amount-card"
                                    :class="{ active: selectedAmount === option.amount }"
                                    @click="selectedAmount = option.amount"
                                >
                                    <div class="amount-main">
                                        <img src="@/assets/static/img2/jindou.png" alt="金豆" class="amount-bean-icon">
                                        {{ option.amount }}
                                    </div>
                                    <div class="amount-unit">豆豆</div>
                                    <div class="price-section">
                                        <div class="amount-price">
                                            <span class="price-number">{{ option.price }}</span>
                                            <span class="price-unit">元</span>
                                        </div>
                                        <div v-if="option.originalPrice > option.price" class="original-price">¥{{ option.originalPrice }}</div>
                                    </div>
                                    <div v-if="option.bonus > 0" class="bonus-tag">
                                        <Present />
                                        省¥{{ option.bonus }}
                                    </div>
 
                                </div>
                            </div>
                        </div>


                    </div>

                    <div class="modal-footer">
                        <div class="footer-info">
                            <span v-if="selectedAmount" class="selected-info">
                                将充值 {{ selectedAmount }} 豆豆
                            </span>
                        </div>
                        <div class="footer-actions">
                            <button class="btn btn-secondary" @click="handleClose">
                                取消
                            </button>
                            <button 
                                class="btn btn-primary" 
                                :class="{ disabled: !selectedAmount }"
                                :disabled="!selectedAmount"
                                @click="handleConfirm"
                            >
                                
                                立即支付 ¥{{ getSelectedPrice() }}
                            </button>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
        </Transition>
        
        <!-- 支付弹窗 -->
        <Transition name="payment-modal">
            <div v-if="showPaymentModal" class="payment-overlay" @click="closePaymentModal">
                <div class="payment-container" @click.stop>
                    <div class="payment-header">
                        <h3 class="payment-title">扫码支付</h3>
                        <button class="payment-close" @click="closePaymentModal">
                            <Close />
                        </button>
                    </div>
                    
                    <div class="payment-body">
                        <!-- 支付方式选择 -->
                        <div class="payment-method-selector">
                            <div 
                                class="payment-method-btn" 
                                :class="{ active: selectedPayment === 'wechat' }"
                                @click="selectPaymentMethod('wechat')"
                            >
                                <ChatDotRound />
                                <span>微信支付</span>
                            </div>
                            <div 
                                class="payment-method-btn" 
                                :class="{ active: selectedPayment === 'alipay' }"
                                @click="selectPaymentMethod('alipay')"
                            >
                                <Money />
                                <span>支付宝</span>
                            </div>
                        </div>
                        
                        <!-- 二维码区域 -->
                        <div class="qrcode-section">
                            <div v-if="qrCodeLoading" class="qrcode-loading">
                                <div class="loading-spinner"></div>
                                <div class="loading-text">正在生成支付二维码...</div>
                            </div>
                            <div v-else-if="paymentData.ewm" class="qrcode-container">
                                <img :src="paymentData.ewm" class="qrcode-image" alt="支付二维码">
                                <div class="qrcode-tip">请使用{{ selectedPayment === 'wechat' ? '微信' : '支付宝' }}扫码支付</div>
                            </div>
                            <div v-else class="qrcode-placeholder">
                                <Picture />
                                <div>二维码生成中...</div>
                            </div>
                        </div>
                        
                        <!-- 支付信息 -->
                        <div class="payment-info-section">
                            <div class="payment-amount">支付金额：¥{{ (paymentData.price || getSelectedPrice() ) / 100 }}</div>
                            <div v-if="countdown > 0" class="payment-countdown">
                                剩余支付时间：{{ formatCountdown }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Transition>
    </Teleport>
</template>

<script>
import { defineComponent, ref, watch, onMounted, onUnmounted, computed } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Money, Close, Wallet, Present, Star, ChatDotRound, Picture, SuccessFilled } from '@element-plus/icons-vue'
import { getRechargePackagesApi, pointsCreateOrderApi, createTransactionApi, payApi, queryPayApi, wxPayApi, wxQueryPayApi } from '@/api/index'

export default defineComponent({
    name: 'RechargeModal',
    components: {
        Money,
        Close,
        Wallet,
        Present,
        Star,
        ChatDotRound,
        Picture,
        SuccessFilled
    },
    props: {
        modelValue: {
            type: Boolean,
            default: false
        },
        userInfo: {
            type: Object,
            default: () => ({})
        }
    },
    emits: ['update:modelValue', 'confirm'],
    setup(props, { emit }) {
        const visible = ref(props.modelValue)
        const selectedAmount = ref(null)
        const selectedPayment = ref('wechat')
        const loading = ref(false)
        const rechargeOptions = ref([])
        
        // 支付相关状态
        const showPaymentModal = ref(false)
        const qrCodeLoading = ref(false)
        const countdown = ref(0)
        let countdownTimer = null
        let paymentCheckTimer = null
        let createOrderTimeout = null
        const isComponentDestroyed = ref(false)
        
        const paymentData = ref({
            gid: '',
            price: 0,
            oid: '',
            tid: '',
            ewm: ''
        })

        // 获取充值套餐列表
        const fetchRechargeOptions = async () => {
            loading.value = true
            try {
                const response = await getRechargePackagesApi({})
                
                if (response.data.success) {
                    // 转换API数据为组件需要的格式
                    rechargeOptions.value = response.data.data.map((option) => ({
                        id: option.id,
                        gid: option.gid,
                        amount: parseFloat(option.package_name), // package_name是豆豆数量
                        price: parseFloat(option.current_price)/100, // current_price是实际价格
                        originalPrice: parseFloat(option.original_price), // 原价
                        bonus: parseFloat(option.discount_rate || 0), // discount_rate作为奖励
                        popular: option.sort_order === '0', // sort_order为0的作为热门
                        description: option.description || '',
                        durationDays: parseInt(option.duration_days || 0)
                    }))
                    
                    // 默认选中第一个套餐
                    if (rechargeOptions.value.length > 0) {
                        selectedAmount.value = rechargeOptions.value[0].amount
                    }
                } else {
                    ElMessage.error('获取充值套餐失败：' + response.data.msg)
                    // 使用默认数据作为后备
                    setDefaultRechargeOptions()
                }
            } catch (error) {
                console.error('获取充值套餐失败:', error)
                ElMessage.error('获取充值套餐失败，使用默认套餐')
                // 使用默认数据作为后备
                setDefaultRechargeOptions()
            } finally {
                loading.value = false
            }
        }

        // 设置默认充值选项（后备方案）
        const setDefaultRechargeOptions = () => {
            rechargeOptions.value = [
                { amount: 100, price: 10, bonus: 0 },
                { amount: 300, price: 30, bonus: 30 },
                { amount: 500, price: 50, bonus: 100 },
                { amount: 1000, price: 100, bonus: 300 },
                { amount: 2000, price: 200, bonus: 800 },
                { amount: 5000, price: 500, bonus: 2000 }
            ]
            selectedAmount.value = 100
        }



        watch(() => props.modelValue, (newVal) => {
            visible.value = newVal
        })

        // 监听支付弹窗关闭，确保清理定时器
        watch(showPaymentModal, (newVal, oldVal) => {
            if (oldVal === true && newVal === false) {
                // 支付弹窗从打开变为关闭时，额外确保清理定时器
                console.log('支付弹窗关闭，清理定时器')
                
                if (countdownTimer) {
                    clearInterval(countdownTimer)
                    countdownTimer = null
                }
                if (paymentCheckTimer) {
                    clearInterval(paymentCheckTimer)
                    paymentCheckTimer = null
                }
                
                countdown.value = 0
                qrCodeLoading.value = false
            }
        })

        const handleVisibilityChange = (value) => {
            emit('update:modelValue', value)
        }

        const handleClose = () => {
            cleanupPayment()
            selectedAmount.value = null
            selectedPayment.value = 'wechat'
            emit('update:modelValue', false)
        }

        const handleOverlayClick = () => {
            handleClose()
        }

        const handleConfirm = async () => {
            if (!selectedAmount.value) {
                ElMessage.warning('请选择充值金额')
                return
            }
            
            const selectedOption = rechargeOptions.value.find(option => option.amount === selectedAmount.value)
            
            // 显示支付弹窗
            showPaymentModal.value = true
            
            // 创建订单
            await createPointsOrder(selectedOption)
        }

        const getSelectedPrice = () => {
            if (!selectedAmount.value) return 0
            const option = rechargeOptions.value.find(opt => opt.amount === selectedAmount.value)
            return option ? option.price : 0
        }

        // 统一清理支付相关状态和定时器
        const cleanupPayment = () => {
            // 清理倒计时定时器
            if (countdownTimer) {
                clearInterval(countdownTimer)
                countdownTimer = null
            }
            
            // 清理支付检查定时器
            if (paymentCheckTimer) {
                clearInterval(paymentCheckTimer)
                paymentCheckTimer = null
            }
            
            // 清理创建订单延迟定时器
            if (createOrderTimeout) {
                clearTimeout(createOrderTimeout)
                createOrderTimeout = null
            }
            
            // 重置所有状态
            paymentData.value = {
                gid: '',
                price: 0,
                oid: '',
                tid: '',
                ewm: ''
            }
            countdown.value = 0
            qrCodeLoading.value = false
            showPaymentModal.value = false
            
            console.log('支付状态已清理完成')
        }

        // 创建积分订单
        const createPointsOrder = async (selectedOption) => {
            if (isComponentDestroyed.value) return
            
            qrCodeLoading.value = true
            try {
                const data = {
                    gid: selectedOption.gid
                }
                
                const res = await pointsCreateOrderApi(data)
                console.log('积分订单创建结果:', res)
                
                if (res.data.success) {
                    paymentData.value.gid = selectedOption.gid
                    paymentData.value.price = res.data.price || selectedOption.price
                    paymentData.value.oid = res.data.oid
                    
                    // 创建交易
                    await createTransaction()
                } else {
                    ElMessage.error(res.data.msg || '创建订单失败')
                    qrCodeLoading.value = false
                    showPaymentModal.value = false
                }
            } catch (error) {
                console.error('创建积分订单失败:', error)
                ElMessage.error('创建订单失败，请稍后重试')
                qrCodeLoading.value = false
                showPaymentModal.value = false
            }
        }

        // 创建交易
        const createTransaction = async () => {
            try {
                const data = {
                    order_list: [paymentData.value.oid],
                    genre: '4' // 积分套餐类型
                }

                const res = await createTransactionApi(data)
                if (res.data.success) {
                    paymentData.value.price = res.data.price
                    paymentData.value.tid = res.data.tid

                    // 根据支付方式生成二维码
                    if (selectedPayment.value === 'alipay') {
                        await handleAlipay()
                    } else {
                        await handleWxPay()
                    }
                } else {
                    ElMessage.error('创建交易失败')
                    qrCodeLoading.value = false
                    showPaymentModal.value = false
                }
            } catch (error) {
                console.error('创建交易失败:', error)
                ElMessage.error('创建交易失败')
                qrCodeLoading.value = false
                showPaymentModal.value = false
            }
        }

        // 支付宝支付
        const handleAlipay = async () => {
            try {
                const data = {
                    out_trade_no: paymentData.value.tid,
                    amount: paymentData.value.price
                }

                const res = await payApi(data)
                if (res.data.alipay_trade_precreate_response.code == '10000') {
                    paymentData.value.ewm = 'data:image/png;base64,' + res.data.alipay_trade_precreate_response.qr_codeimg
                    qrCodeLoading.value = false
                    startPaymentCheck()
                } else {
                    ElMessage.error('获取支付二维码失败')
                    qrCodeLoading.value = false
                }
            } catch (error) {
                console.error('支付宝支付失败:', error)
                ElMessage.error('支付失败')
                qrCodeLoading.value = false
            }
        }

        // 微信支付
        const handleWxPay = async () => {
            try {
                const data = {
                    out_trade_no: paymentData.value.tid,
                    amount: paymentData.value.price
                }

                const res = await wxPayApi(data)
                if (res.data.return_code === 'SUCCESS') {
                    paymentData.value.ewm = 'data:image/png;base64,' + res.data.code_url_img
                    qrCodeLoading.value = false
                    startPaymentCheck()
                } else {
                    ElMessage.error('获取支付二维码失败')
                    qrCodeLoading.value = false
                }
            } catch (error) {
                console.error('微信支付失败:', error)
                ElMessage.error('支付失败')
                qrCodeLoading.value = false
            }
        }

        // 选择支付方式
        const selectPaymentMethod = (method) => {
            if (selectedPayment.value === method) return
            
            selectedPayment.value = method
            
            // 如果已有订单，重新生成二维码
            if (paymentData.value.tid) {
                qrCodeLoading.value = true
                if (method === 'wechat') {
                    handleWxPay()
                } else {
                    handleAlipay()
                }
            }
        }

        // 开始支付检查
        const startPaymentCheck = () => {
            // 先清理之前可能存在的定时器
            if (countdownTimer) {
                clearInterval(countdownTimer)
                countdownTimer = null
            }
            if (paymentCheckTimer) {
                clearInterval(paymentCheckTimer)
                paymentCheckTimer = null
            }
            
            countdown.value = 300
            
            countdownTimer = setInterval(() => {
                if (countdown.value > 0) {
                    countdown.value--
                } else {
                    // 先清理定时器，再显示消息
                    clearInterval(countdownTimer)
                    clearInterval(paymentCheckTimer)
                    countdownTimer = null
                    paymentCheckTimer = null
                    countdown.value = 0
                    showPaymentModal.value = false
                    qrCodeLoading.value = false
                    
                    // 重置支付数据
                    paymentData.value = {
                        gid: '',
                        price: 0,
                        oid: '',
                        tid: '',
                        ewm: ''
                    }
                    
                    ElMessage.warning('支付超时，请重新选择套餐')
                }
            }, 1000)
            
            paymentCheckTimer = setInterval(() => {
                checkPaymentStatus()
            }, 3000)
        }

        // 检查支付状态
        const checkPaymentStatus = async () => {
            if (!paymentData.value.tid) return
            
            try {
                const data = {
                    out_trade_no: paymentData.value.tid
                }

                if (selectedPayment.value === 'alipay') {
                    const res = await queryPayApi(data)
                    if (res.data.code == '200') {
                        handlePaymentSuccess()
                    }
                } else {
                    const res = await wxQueryPayApi(data)
                    if (res.data.trade_state == 'SUCCESS') {
                        handlePaymentSuccess()
                    }
                }
            } catch (error) {
                console.error('检查支付状态失败:', error)
            }
        }

        // 处理支付成功
        const handlePaymentSuccess = () => {
            const orderInfo = {
                oid: paymentData.value.oid,
                price: paymentData.value.price / 100 // 转换为元单位显示
            }
            
            cleanupPayment()
            
            ElMessage.success('充值成功！')
            
            // 关闭弹窗
            emit('update:modelValue', false)
            
            // 显示成功提示
            ElMessageBox.alert(
                `<div style="text-align: center; padding: 20px;">
                    <div style="font-size: 48px; color: #67C23A; margin-bottom: 16px;">
                        <SuccessFilled />
                    </div>
                    <h3 style="margin: 0 0 16px; color: #333;">充值成功！</h3>
                    <p style="margin: 0; color: #666;">
                        订单号：${orderInfo.oid}<br>
                        支付金额：¥${orderInfo.price}<br>
                        豆豆已到账，感谢您的支持！
                    </p>
                </div>`,
                '充值成功',
                {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '好的'
                }
            )
        }

        // 格式化倒计时
        const formatCountdown = computed(() => {
            const minutes = Math.floor(countdown.value / 60)
            const seconds = countdown.value % 60
            return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
        })

        // 关闭支付弹窗
        const closePaymentModal = () => {
            cleanupPayment()
            // 重置二维码加载状态
            qrCodeLoading.value = false
        }

        // 组件挂载时获取充值套餐数据
        onMounted(() => {
            fetchRechargeOptions()
            
            // 监听页面关闭事件
            const handleBeforeUnload = () => {
                isComponentDestroyed.value = true
                cleanupPayment()
            }
            window.addEventListener('beforeunload', handleBeforeUnload)
            window._rechargeModalBeforeUnloadHandler = handleBeforeUnload
        })

        // 组件卸载时清理定时器
        onUnmounted(() => {
            isComponentDestroyed.value = true
            cleanupPayment()
            
            if (window._rechargeModalBeforeUnloadHandler) {
                window.removeEventListener('beforeunload', window._rechargeModalBeforeUnloadHandler)
                window._rechargeModalBeforeUnloadHandler = null
            }
        })

        return {
            visible,
            selectedAmount,
            selectedPayment,
            rechargeOptions,
            loading,
            showPaymentModal,
            qrCodeLoading,
            countdown,
            paymentData,
            handleVisibilityChange,
            handleClose,
            handleOverlayClick,
            handleConfirm,
            getSelectedPrice,
            fetchRechargeOptions,
            selectPaymentMethod,
            formatCountdown,
            closePaymentModal
        }
    }
})
</script>

<style scoped>
/* 模态框动画 */
.modal-enter-active, .modal-leave-active {
    transition: all 0.3s ease;
}

.modal-enter-from, .modal-leave-to {
    opacity: 0;
}

.modal-enter-active .modal-container,
.modal-leave-active .modal-container {
    transition: all 0.3s ease;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
    opacity: 0;
    transform: scale(0.9) translateY(-20px);
}

/* 遮罩层 */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    padding: 20px;
}

/* 主容器 */
.modal-container {
    background: white;
    border-radius: 20px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
    max-width: 580px;
    width: 100%;
    max-height: 90vh;
    overflow: visible;
    display: flex;
    flex-direction: column;
    position: relative;
}

/* 弹窗内容区域 - 保持圆角 */
.modal-content-wrapper {
    border-radius: 10px;
    overflow: hidden;
    flex: 1;
    display: flex;
    flex-direction: column;
}

/* 金豆装饰图片 */
.bean-decoration {
    position: absolute;
    top: -30px;
    left: -30px;
    z-index: 10;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.bean-image {
    width: 100px;
    height: 100px;
    object-fit: contain;
}

/* 头部 */
.modal-header {
    background: linear-gradient(90deg, #FFFFFF 0%, #FFD6BD 100%);
    color: white;
    padding: 24px 30px;
    position: relative;
}

.header-content {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
    position: relative;
}

.title-section {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    width: 100%;
}

.modal-icon {
    width: 48px;
    height: 48px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
}

.modal-icon svg {
    width: 24px;
    height: 24px;
}

.title-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
}

.modal-title {
    font-size: 20px;
    font-weight: 600;
    margin: 0;
    color: #000000;
}

.modal-subtitle {
    font-size: 12px;
    font-weight: 400;
    margin: 0;
    color: #666666;
    opacity: 0.8;
    position: relative;
    padding: 0 20px;
}

.modal-subtitle::before,
.modal-subtitle::after {
    content: '';
    position: absolute;
    top: 50%;
    width: 15px;
    height: 1px;
    background-color: #666666;
    opacity: 0.6;
}

.modal-subtitle::before {
    left: 0;
}

.modal-subtitle::after {
    right: 0;
}

.close-button {
    width: 36px;
    height: 36px;
    border: none;
    background: rgba(255, 255, 255, 0);
    color: #000000;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;
    position: absolute;
    top: -20px;
    right: -24px;
}

.close-button svg {
    width: 16px;
    height: 16px;
}

.close-button:hover {

    transform: rotate(90deg);
}

.balance-info {
    margin-top: 16px;
}

.balance-card {
    background: url('@/assets/static/img2/re_bg.png') no-repeat center center;
    backdrop-filter: blur(10px);
    border-radius: 12px;
    padding: 16px 20px;
    display: flex;
    align-items: center;
    gap: 16px;
    border: 1px solid rgba(255, 255, 255, 0.2);
}


.balance-content {
    display: flex;
    gap: 290px;
    align-items: center;
    background: linear-gradient(34.648667497948125deg, #CA915E 0%, #823B08 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: 0.5px;
}

.balance-label {
    font-size: 15px;
    font-weight: 600;
    
}

.balance-value {
    font-size: 20px;
    font-weight: 500;
}

.balance-number {
    font-size: 32px;
    font-weight: 800;
}

.balance-unit {
    font-size: 14px;
    font-weight: 500;
}

/* 主体内容 */
.modal-body {
    padding: 30px;
    flex: 1;
    overflow-y: auto;
}

.section {
    margin-bottom: 32px;
}

.section:last-child {
    margin-bottom: 0;
}

.section-title {
    font-size: 18px;
    font-weight: 600;
    color: #2c3e50;
    margin: 0 0 20px 0;
    display: flex;
    align-items: center;
    gap: 8px;
}

/* 加载状态 */
.loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px;
    width: 100%;
}

.loading-spinner {
    width: 32px;
    height: 32px;
    border: 3px solid #f3f4f6;
    border-top: 3px solid #3b82f6;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 12px;
}

.loading-text {
    color: #64748b;
    font-size: 14px;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.section-title::before {
    content: '';
    width: 4px;
    height: 20px;
    background: linear-gradient(90deg, #338bff 0%, #0066ff 100%);
    border-radius: 2px;
}

/* 充值金额网格 */
.amount-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
}

.amount-card {
    background: #F2F2F2;
    border-radius: 16px;
    padding: 32px 16px 0px 16px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;

    overflow: hidden;
}

.amount-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
   
    opacity: 0;
    transition: opacity 0.3s;
    z-index: -1;
}

.amount-card:hover {
    border-color: #4285f4;
    transform: translateY(-4px);
    border: 2px solid #005DFF;
}

.amount-card.active {
    border-color: #4285f4;
    border: 2px solid #005DFF;
    transform: translateY(-4px);


}

.amount-card.active::before {
    opacity: 1;
}

.amount-main {
    font-size: 28px;
    font-weight: 700;
    line-height: 1;
    margin-bottom: 4px;
    background: linear-gradient(34.648667497948125deg, #CA915E 0%, #823B08 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-align: center;
    position: relative;
}

.amount-main .amount-bean-icon {
    position: absolute;
    left: 13px;
    top: 50%;
    transform: translateY(-50%);
}

.amount-unit {
    font-size: 12px;
    opacity: 0.8;
    margin-bottom: 12px;
    font-weight: 600;
    background: linear-gradient(34.648667497948125deg, #CA915E 0%, #823B08 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    border-bottom: 1px solid #D8D8D8;
    padding-bottom: 23px;
    text-align: center;
}

.amount-bean-icon {
    width: 27px;
    height: 27px;
    object-fit: contain;
}

.price-section {
    margin-bottom: 8px;
}

.amount-price {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 2px;
    display: flex;
    align-items: baseline;
    justify-content: center;
    gap: 2px;
}

.price-number {
    font-size: 24px;
    font-weight: 700;
    color: #333;
}

.price-unit {
    font-size: 12px;
    font-weight: 500;
    color: #666;
}

.original-price {
    font-size: 12px;
    color: #999;
    text-decoration: line-through;
    opacity: 0.7;
}

.bonus-tag {
    background: linear-gradient( 180deg, #4B473F 0%, #211F1C 100%);
    color: #FFF1C7;
    font-size: 10px;
    padding: 4px 8px;
    border-radius: 12px;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-weight: 600;
    position: absolute;
    top: 2px;
    right: 4px;
    border-radius: 0px 10px 0px 10px;
}

.bonus-tag svg {
    width: 12px;
    height: 12px;
    top: 8px;
    right: 8px;
}

.popular-tag {
    background: #f39c12;
    color: #FFF1C7;
    font-size: 12px;
    padding: 4px 8px;
    border-radius: 12px;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-weight: 600;
    position: absolute;
    top: 8px;
    left: 8px;
}



/* 底部 */
.modal-footer {
    padding: 24px 30px;
    background: #ffffff;

    display: flex;
    justify-content: space-between;
    align-items: center;
}

.footer-info {
    flex: 1;
}

.selected-info {
    font-size: 13px;
    color: #4285f4;
    font-weight: 500;
}

.footer-actions {
    display: flex;
    gap: 12px;
}

.btn {
    padding: 12px 24px;
    border-radius: 4px;
    border: none;
    font-size: 12px;

    cursor: pointer;
    transition: all 0.3s;
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 120px;
    justify-content: center;
}

.btn-secondary {
    background: #e8ecf3;
    color: #64748b;
    font-size: 11px;
}

.btn-secondary:hover {
    background: #d1d9e6;
    transform: translateY(-1px);
}

.btn-primary {
    background: linear-gradient(90deg, #338bff 0%, #0066ff 100%);
    color: white;
}

.btn-primary svg {
    width: 16px;
    height: 16px;
}

.btn-primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
}

.btn-primary.disabled {
    background: #cbd5e1;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .modal-overlay {
        padding: 16px;
    }
    
    .modal-header {
        padding: 20px 24px;
    }
    
    .modal-body {
        padding: 24px;
    }
    
    .amount-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 12px;
    }
    
    .amount-card {
        padding: 16px;
    }
    
    .modal-footer {
        padding: 20px 24px;
        flex-direction: column;
        gap: 16px;
        align-items: stretch;
    }
    
    .footer-actions {
        flex-direction: column;
    }
    
    .btn {
        width: 100%;
    }
}

@media (max-width: 480px) {
    .amount-grid {
        grid-template-columns: 1fr;
    }
    
    .modal-title {
        font-size: 20px;
    }
    
    .section-title {
        font-size: 16px;
    }
}

/* 支付弹窗样式 */
.payment-modal-enter-active, .payment-modal-leave-active {
    transition: all 0.3s ease;
}

.payment-modal-enter-from, .payment-modal-leave-to {
    opacity: 0;
}

.payment-modal-enter-active .payment-container,
.payment-modal-leave-active .payment-container {
    transition: all 0.3s ease;
}

.payment-modal-enter-from .payment-container,
.payment-modal-leave-to .payment-container {
    opacity: 0;
    transform: scale(0.9) translateY(-20px);
}

.payment-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(6px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    padding: 20px;
}

.payment-container {
    background: white;
    border-radius: 20px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    max-width: 400px;
    width: 100%;
    max-height: 90vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.payment-header {
    padding: 24px 30px 20px;
    border-bottom: 1px solid #f0f0f0;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.payment-title {
    font-size: 20px;
    font-weight: 600;
    color: #333;
    margin: 0;
}

.payment-close {
    width: 32px;
    height: 32px;
    border: none;
    background: #f5f5f5;
    color: #666;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.payment-close svg {
    width: 14px;
    height: 14px;
    transition: all 0.3s;
}

.payment-close:hover {
    background: #e8e8e8;
    transform: rotate(90deg);
}

.payment-body {
    padding: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.payment-method-selector {
    display: flex;
    gap: 12px;
    margin-bottom: 30px;
    width: 100%;
}

.payment-method-btn {
    flex: 1;
    padding: 12px 16px;
    border: 2px solid #e8ecf3;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    cursor: pointer;
    transition: all 0.3s;
}

.payment-method-btn svg {
    width: 18px;
    height: 18px;
    background: white;
    color: #666;
}

.payment-method-btn:hover {
    border-color: #667eea;
    color: #667eea;
}

.payment-method-btn.active {
    border-color: #667eea;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
}

.qrcode-section {
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.qrcode-loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 200px;
    height: 200px;
    border: 2px dashed #d1d5db;
    border-radius: 16px;
    background: #f8fafc;
}

.qrcode-container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.qrcode-image {
    width: 200px;
    height: 200px;
    border-radius: 16px;
    border: 2px solid #e8ecf3;
    margin-bottom: 12px;
}

.qrcode-tip {
    font-size: 14px;
    color: #666;
    text-align: center;
}

.qrcode-placeholder {
    width: 200px;
    height: 200px;
    border: 2px dashed #d1d5db;
    border-radius: 16px;
    background: #f8fafc;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #999;
}

.qrcode-placeholder svg {
    width: 48px;
    height: 48px;
    margin-bottom: 12px;
    color: #ccc;
    font-size: 14px;
}

.qrcode-placeholder i {
    font-size: 48px;
    margin-bottom: 12px;
    color: #ccc;
}

.payment-info-section {
    text-align: center;
    width: 100%;
}

.payment-amount {
    font-size: 20px;
    font-weight: 600;
    color: #333;
    margin-bottom: 8px;
}

.payment-countdown {
    font-size: 14px;
    color: #f59e0b;
    font-weight: 600;
}

@media (max-width: 480px) {
    .payment-overlay {
        padding: 16px;
    }
    
    .payment-container {
        max-width: 100%;
    }
    
    .payment-header {
        padding: 20px 24px 16px;
    }
    
    .payment-body {
        padding: 24px;
    }
    
    .payment-method-selector {
        flex-direction: column;
        gap: 8px;
    }
    
    .qrcode-image {
        width: 160px;
        height: 160px;
    }
    
    .qrcode-loading,
    .qrcode-placeholder {
        width: 160px;
        height: 160px;
    }
}
</style>
